import script from "./SignUpView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpView.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpView.vue?vue&type=style&index=0&id=053c09c4&lang=scss"

const __exports__ = script;

export default __exports__